(function () {
  function getBundleId(row) {
    var id = row && row.getAttribute('data-fam-plus-id');
    return id && id.trim() !== '' ? id : null;
  }

  function ensureModal() {
  var modal = document.getElementById('fam-plus-remove-modal');
  if (modal) return modal;

  // Inject styles once
  if (!document.getElementById('fam-plus-modal-styles')) {
    var style = document.createElement('style');
    style.id = 'fam-plus-modal-styles';
    style.textContent =
      '#fam-plus-remove-modal { display: none; position: fixed; inset: 0; z-index: 999999; }' +
      '.fam-plus-modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center; padding: 16px; }' +
      '.fam-plus-modal-box { background: #fff; border-radius: 12px; padding: 24px; max-width: 360px; width: 100%; text-align: center; font-family: inherit; }' +
      '.fam-plus-modal-box h3 { font-size: 16px; font-weight: 800; margin: 0 0 8px; color: #1a1a1a; }' +
      '.fam-plus-modal-box p { font-size: 13px; color: #555; margin: 0 0 20px; }' +
      '.fam-plus-modal-actions { display: flex; gap: 10px; }' +
      '.fam-plus-modal-cancel, .fam-plus-modal-remove { flex: 1; padding: 10px 0; border-radius: 8px; font-size: 13px; font-weight: 700; cursor: pointer; border: 2px solid #1a1a1a; }' +
      '.fam-plus-modal-cancel { background: #fff; color: #1a1a1a; }' +
      '.fam-plus-modal-remove { background: #1a1a1a; color: #fff; }';
    document.head.appendChild(style);
  }

  modal = document.createElement('div');
  modal.id = 'fam-plus-remove-modal';
  modal.innerHTML =
    '<div class="fam-plus-modal-overlay">' +
      '<div class="fam-plus-modal-box">' +
        '<h3>These products are sold together.</h3>' +
        '<p>Removing one product will also remove its paired product.</p>' +
        '<div class="fam-plus-modal-actions">' +
          '<button type="button" class="fam-plus-modal-cancel">Cancel</button>' +
          '<button type="button" class="fam-plus-modal-remove">Remove Both</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);
  return modal;
}

  function showConfirm(onConfirm) {
    var modal = ensureModal();
    modal.style.display = 'block';

    var cancelBtn = modal.querySelector('.fam-plus-modal-cancel');
    var removeBtn = modal.querySelector('.fam-plus-modal-remove');

    function cleanup() {
      modal.style.display = 'none';
      cancelBtn.removeEventListener('click', onCancel);
      removeBtn.removeEventListener('click', onRemove);
    }
    function onCancel() { cleanup(); }
    function onRemove() { cleanup(); onConfirm(); }

    cancelBtn.addEventListener('click', onCancel);
    removeBtn.addEventListener('click', onRemove);
  }

  function removeBundle(bundleId) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (item) {
          if (item.properties && item.properties._fam_plus_id === bundleId) {
            updates[item.key] = 0;
          }
        });
        console.log('Fam Plus: removing bundle', bundleId, updates);
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (result) {
        console.log('Fam Plus: cart updated', result);
        window.location.reload();
      })
      .catch(function (err) {
        console.error('Fam Plus removal failed:', err);
      });
  }

  document.addEventListener('click', function (e) {
    var removeEl = e.target.closest('cart-remove-button a, cart-remove-button, .cart-remove-button');
    if (!removeEl) return;

    var row = e.target.closest('[data-fam-plus-id]');
    var bundleId = getBundleId(row);
    if (!bundleId) return;

    console.log('Fam Plus: intercepted remove click for bundle', bundleId);

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    showConfirm(function () { removeBundle(bundleId); });
  }, true);

  document.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('button[name="minus"]');
    if (!minusBtn) return;

    var row = e.target.closest('[data-fam-plus-id]');
    var bundleId = getBundleId(row);
    if (!bundleId) return;

    var qtyInput = row.querySelector('input.quantity__input');
    var currentQty = qtyInput ? parseInt(qtyInput.value, 10) : null;
    if (currentQty !== 1) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    showConfirm(function () { removeBundle(bundleId); });
  }, true);
})();  